// One-time bootstrap that fetches KV overrides and primes the `overrides` store.
// Called from main.ts so every route boots with merged content.

import { fetchContent } from "./api";
import { overrides, overridesLoaded } from "./content";

let started = false;

export async function loadOverrides(): Promise<void> {
  if (started) return;
  started = true;
  try {
    const { overrides: map } = await fetchContent();
    overrides.set(map);
  } catch (err) {
    // Backend not deployed or offline - keep showing static stubs only.
    // (This happens during `npm run dev` with no wrangler in front.)
    console.warn("[playbook] could not load overrides, falling back to stubs:", err);
  } finally {
    overridesLoaded.set(true);
  }
}

/** Merge a single freshly-saved override into the in-memory store. */
export function applyOverride(slug: string, markdown: string): void {
  overrides.update((m) => ({ ...m, [slug]: markdown }));
}

/** Drop an override from the in-memory store (slug reverts to its stub). */
export function dropOverride(slug: string): void {
  overrides.update((m) => {
    const next = { ...m };
    delete next[slug];
    return next;
  });
}
